@if (loaderIcon | async) {
    <app-loader></app-loader>
}
<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        <div class="content-area" [userPermissionHandler]="viewPermissionHandlerData">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="fw-semibold">POS Terminals</h5>
                <ejs-tooltip id='tooltipbtnNew'  target="#posTerminalNew" position='LeftCenter' (beforeOpen)="onBeforeOpen($event)">
                    <button class="btn btnAS" id="posTerminalNew" [userPermissionHandler]="createPermissionHandlerData" (click)="clickNewTerminal()">NEW</button>
                </ejs-tooltip>
            </div>
            <hr />
            <div class="row">
                <div class="col-md-12 col-lg-8 text-start mt-2">
                    
                    <div class="mb-3 d-flex gap-3 align-items-center">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" id="rdAll" type="radio" name="status" value="All"
                                [checked]="activeTab == 'All'" (change)="applyFilter('All')" />
                            <label class="form-check-label" for="rdAll">All</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" id="rdActive" type="radio" name="status" value="Active"
                                [checked]="activeTab == 'Active'" (change)="applyFilter('Active')" />
                            <label class="form-check-label" for="rdActive">Active</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" id="rdInactive" type="radio" name="status" value="Inactive"
                                [checked]="activeTab == 'InActive'" (change)="applyFilter('InActive')" />
                            <label class="form-check-label" for="rdInactive">Inactive</label>
                        </div>
                    </div>
                    
                    <ejs-grid #posTerminalGrid [dataSource]='terminals' (created)='created()' (dataBound)='dataBound($event)' [allowFiltering]="true" height='250' (rowSelected)="onTerminalRowSelected($event)">
                        <e-columns>
                            <e-column field='Name' headerText="Terminal" width='280'>
                            </e-column>
                            <e-column field="InActive" headerText="Active / Inactive" textAlign="Center" width="150">
                                <ng-template #template let-data>
                                    <span class="status-dot" [ngStyle]="{'background-color': data.InActive ? inactiveColor : activeColor}"></span>
                                </ng-template>
                            </e-column>
                            <e-column headerText='Delete' field="Delete" width='100' textAlign="Center" >
                                <ng-template #template let-data>
                                <ejs-tooltip id='tooltipbtnDelete'  target="#posTerminalDel" position='LeftCenter' (beforeOpen)="onBeforeOpen($event)">
                                    <button class="btn btn-link p-0" id="posTerminalDel" (click)="deleteRow(data)" [userPermissionHandler]="deletePermissionHandlerData">
                                        <img src="./assets/images/delete.svg" width="20" height="20" />
                                    </button>
                                </ejs-tooltip>
                                </ng-template>
                            </e-column>
                        </e-columns>
                    </ejs-grid>

                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="modalPosTerminals" #modalPosTerminals tabindex="-1" aria-labelledby="modalPosTerminals" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5">POS Terminals</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="mb-3">
                    <label for="productCategory" class="form-label">POS Terminals</label>
                    <input type="text" id="productCategory" class="form-control" maxlength="25" [(ngModel)]="formTerminalName" (keyup)="validatePartDescriptionExists($event)" />
                    @if(posTerminalNameExists) {
                                <div class="alert alert-danger">
                                    <span> POS Terminal Name exists!</span>
                                </div>
                    }
                </div>
                <div class="form-check mb-3">
                    <input class="form-check-input" type="checkbox" id="activeTerminal" [(ngModel)]="formTerminalInActive">
                    <label class="form-check-label" for="activeTerminal">In-Active</label>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btnAS" (click)="clickSavePOSTerminal()" [disabled]="posTerminalNameExists || formTerminalName.trim() == '' || (this.formPOSTerminalID != 0 && (this.currentTerminalName == formTerminalName && this.currentInActive == formTerminalInActive ))">Save</button>
                <button type="button" class="btn btn-orange" data-bs-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>